// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__38u7Y","header":"Messages_header__1rGfO"};